import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { jsx } from '@emotion/core';
import * as React from 'react';
import splitStyles from '../system/split-styles';
import { useVariant } from '../VariantProvider';

function getTemplateValue(value) {
  return value ? value.constructor === Array ? value.map(function (v) {
    return typeof v === 'number' ? v * 8 + "px" : v;
  }).join(' ') : value : undefined;
}

var gridViewPlugin = {
  styleProps: ['autoFlow', 'autoColumns', 'autoRows', 'columns', 'rows', 'alignment', 'distribution', 'columnSpacing', 'rowSpacing', 'spacing'],
  getStyles: function getStyles(_ref) {
    var autoFlow = _ref.autoFlow,
        autoColumns = _ref.autoColumns,
        autoRows = _ref.autoRows,
        columns = _ref.columns,
        rows = _ref.rows,
        alignment = _ref.alignment,
        distribution = _ref.distribution,
        columnSpacing = _ref.columnSpacing,
        rowSpacing = _ref.rowSpacing,
        spacing = _ref.spacing,
        styles = _objectWithoutPropertiesLoose(_ref, ["autoFlow", "autoColumns", "autoRows", "columns", "rows", "alignment", "distribution", "columnSpacing", "rowSpacing", "spacing"]);

    if (autoFlow !== undefined && styles.gridAutoFlow === undefined) {
      styles.gridAutoFlow = autoFlow;
    }

    if (autoColumns !== undefined && styles.gridAutoColumns === undefined) {
      styles.gridAutoColumns = autoColumns;
    }

    if (autoRows !== undefined && styles.autoRows === undefined) {
      styles.gridAutoRows = autoRows;
    }

    if (columns !== undefined && styles.gridTemplateColumns === undefined) {
      styles.gridTemplateColumns = getTemplateValue(columns);
    }

    if (rows !== undefined && styles.gridTemplateRows === undefined) {
      styles.gridTemplateRows = getTemplateValue(rows);
    }

    if (alignment !== undefined && styles.alignItems === undefined) {
      styles.alignItems = alignment;
    }

    if (distribution !== undefined && styles.distribution === undefined) {
      styles.justifyItems = distribution;
    }

    if (columnSpacing !== undefined && styles.gridColumnGap === undefined) {
      styles.gridColumnGap = columnSpacing * 8;
    }

    if (rowSpacing !== undefined && styles.gridRowGap === undefined) {
      styles.gridRowGap = rowSpacing * 8;
    }

    if (spacing !== undefined && styles.gridGap === undefined) {
      styles.gridGap = spacing * 8;
    }

    return styles;
  }
};
var defaultElement = 'div';
export function GridView(_ref2) {
  var as = _ref2.as,
      inline = _ref2.inline,
      innerRef = _ref2.innerRef,
      props = _objectWithoutPropertiesLoose(_ref2, ["as", "inline", "innerRef"]);

  var Element = as || defaultElement;
  var variant = useVariant();
  return jsx(Element, _extends({
    ref: innerRef
  }, splitStyles(_objectSpread({
    display: inline ? 'inline-grid' : 'grid',
    autoColumns: 'minmax(0, auto)',
    plugin: gridViewPlugin,
    variant: variant
  }, props))));
}